import { render, staticRenderFns } from "./AvailableAssetBlock.vue?vue&type=template&id=24a9275a&scoped=true&"
import script from "./AvailableAssetBlock.vue?vue&type=script&lang=js&"
export * from "./AvailableAssetBlock.vue?vue&type=script&lang=js&"
import style0 from "./AvailableAssetBlock.vue?vue&type=style&index=0&id=24a9275a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a9275a",
  null
  
)

export default component.exports